import { Text } from '@viapeople/components'
import { Link } from 'react-router-dom'

interface SftpKey {
	id: string
	fingerprint: string
	label: string | null
	createdAt: string | Date
}

interface ConnectionInfo {
	host: string
	port: number
	username: string
}

interface SftpKeyStatusBannerProps {
	organizationId: string
	keys: SftpKey[]
	connectionInfo: ConnectionInfo | null
	isLoading: boolean
}

export function SftpKeyStatusBanner({ organizationId, keys, connectionInfo, isLoading }: SftpKeyStatusBannerProps) {
	if (isLoading) {
		return null
	}

	const sftpKeysPath = `/organizations/${organizationId}/sftp`

	if (keys.length === 0) {
		return (
			<div className='bg-warning-50 border border-warning-200 rounded-lg p-4 mb-4'>
				<Text variant='small' weight='semibold' className='mb-1'>
					SSH Keys Required
				</Text>
				<Text variant='small' className='text-neutral-600 mb-2'>
					Generate SSH keys to enable SFTP file uploads for this data feed.
				</Text>
				<Link to={sftpKeysPath} className='text-sm text-primary-700 hover:text-primary-800 font-medium'>
					Manage SFTP Keys
				</Link>
			</div>
		)
	}

	const keyCount = keys.length
	const keyLabel = keyCount === 1 ? '1 active key' : `${keyCount} active keys`

	return (
		<div className='bg-primary-50 border border-primary-200 rounded-lg p-4 mb-4'>
			<Text variant='small' weight='semibold' className='mb-2'>
				SFTP Connection Details
			</Text>
			{connectionInfo && (
				<div className='grid grid-cols-3 gap-2 mb-2'>
					<div>
						<Text variant='small' className='text-neutral-500'>
							Host
						</Text>
						<Text variant='small' weight='semibold'>
							{connectionInfo.host}
						</Text>
					</div>
					<div>
						<Text variant='small' className='text-neutral-500'>
							Port
						</Text>
						<Text variant='small' weight='semibold'>
							{connectionInfo.port}
						</Text>
					</div>
					<div>
						<Text variant='small' className='text-neutral-500'>
							Username
						</Text>
						<Text variant='small' weight='semibold'>
							{connectionInfo.username}
						</Text>
					</div>
				</div>
			)}
			<Text variant='small' className='text-neutral-600 mb-2'>
				{keyLabel}
			</Text>
			<Link to={sftpKeysPath} className='text-sm text-primary-700 hover:text-primary-800 font-medium'>
				Manage SFTP Keys
			</Link>
		</div>
	)
}
